import { Button, Text } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { trackHouseholdsExplainerToggled } from 'src/Services/Mixpanel/events';

import styles from './HouseholdsExplainer.module.scss';

const HouseholdsExplainer = () => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(true);

  const toggle = () => {
    const next = !opened;
    setOpened(next);
    trackHouseholdsExplainerToggled({ opened: next });
  };

  const cards = [
    {
      key: 'planning',
      emoji: '📅',
      title: t('admin.households.explainer.planning.title', 'Un planning partagé'),
      body: t(
        'admin.households.explainer.planning.body',
        'Quand un séjour est réservé pour un foyer, tous ses membres le retrouvent automatiquement dans le planning.'
      ),
    },
    {
      key: 'budget',
      emoji: '💰',
      title: t('admin.households.explainer.budget.title', 'Un budget par foyer'),
      body: t(
        'admin.households.explainer.budget.body',
        'Les dépenses du bien peuvent être réparties par foyer plutôt que membre par membre.'
      ),
    },
    {
      key: 'representative',
      emoji: '🗳️',
      title: t('admin.households.explainer.representative.title', 'Un représentant'),
      body: t(
        'admin.households.explainer.representative.body',
        'Chaque foyer désigne son interlocuteur privilégié pour les votes, les réunions et le suivi du budget.'
      ),
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text fw={600}>{t('admin.households.explainer.title', 'Pourquoi créer des foyers ?')}</Text>
        <Button
          variant="light"
          size="xs"
          leftSection={opened ? <IconChevronUp size={14} /> : <IconChevronDown size={14} />}
          onClick={toggle}
        >
          {opened
            ? t('admin.households.explainer.collapse', 'Replier')
            : t('admin.households.explainer.expand', 'Déplier')}
        </Button>
      </div>
      {opened && (
        <div className={styles.body}>
          <Text size="sm" className={styles.intro}>
            {t(
              'admin.households.explainer.intro',
              'Regrouper les membres en foyers permet de simplifier le planning, le budget et les votes.'
            )}
          </Text>
          <div className={styles.grid}>
            {cards.map(card => (
              <div key={card.key} className={styles.card}>
                <div className={styles.cardHeader}>
                  <span className={styles.emoji}>{card.emoji}</span>
                  <span>{card.title}</span>
                </div>
                <Text size="sm" c="dimmed">
                  {card.body}
                </Text>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default HouseholdsExplainer;
